import { createI18n } from "vue-i18n";
import enUS from "./lang/en-US.json";

const i18n = createI18n({
  locale: localStorage.getItem("locale") || "en-US",
  fallbackLocale: "en-US",
  globalInjection: true,
  legacy: false,
  messages: {
    "en-US": enUS,
  },
});

export default i18n;
